import { createContext, useContext } from 'react'

export const initialInternalAssetCounts = { codeCount: -1, pageCount: -1 }
export const InternalAssetsContext = createContext(initialInternalAssetCounts)

export const useInternalAssetsData = (): Record<string, number> => {
  const context = useContext(InternalAssetsContext)
  if (!context) {
    throw new Error('useInternalAssetsData must be used within the StateContextProvider')
  }
  return context
}
